const imageStatus = new Map();
const imagePromises = new Map();
const failedUntil = new Map();

const MAX_RETRIES = 2;
const RETRY_DELAY = 1000;
const FAILURE_TTL = 10000;

const loadImage = url =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject(new Error('image load failed'));
    img.src = url;
  });

export const fetchImage = async (url, setImage) => {
  if (!url) {
    return;
  }

  const failedUntilAt = failedUntil.get(url);
  if (failedUntilAt && failedUntilAt > Date.now()) {
    return;
  }

  if (imageStatus.get(url) === 'loaded') {
    setImage(url);
    return;
  }

  if (imagePromises.has(url)) {
    try {
      await imagePromises.get(url);
      setImage(url);
    } catch (error) {
      // noop
    }
    return;
  }

  const promise = (async () => {
    for (let attempt = 1; attempt <= MAX_RETRIES; attempt += 1) {
      try {
        await loadImage(url);
        imageStatus.set(url, 'loaded');
        failedUntil.delete(url);
        return;
      } catch (error) {
        if (attempt < MAX_RETRIES) {
          await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
        } else {
          failedUntil.set(url, Date.now() + FAILURE_TTL);
          throw error;
        }
      }
    }
  })();

  imagePromises.set(url, promise);
  try {
    await promise;
    setImage(url);
  } catch (error) {
    // noop
  } finally {
    imagePromises.delete(url);
  }
};
